// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfigTabs_wrapper__JvlBE","tab_box":"ConfigTabs_tab_box__p3oLH"};